<template>
  <div class="slider-element">
    <range-slider-fi
      class="fi-px-6"
      :min="minValue"
      :max="maxValue"
      :value="[lower, upper]"
      :disabled="disabled"
      :interval="interval"
      @drag-end="onDragEndSlider"
      @change="onChangeSlider"
    />
    <div class="slider-element__text-input">
      <text-input-fi
        :model-value="lowerAsString"
        :label="`[${group.unit}]`"
        :disabled="disabled"
        :min="minValue"
        :max="maxValue"
        data-test="range-value-lower"
        show-localized-values
        @change="onInputLower"
      />
      <div class="fi-px-12">-</div>
      <text-input-fi
        :model-value="upperAsString"
        :label="`[${group.unit}]`"
        :disabled="disabled"
        :min="minValue"
        :max="maxValue"
        data-test="range-value-upper"
        show-localized-values
        @change="onInputUpper"
      />
    </div>
  </div>
</template>

<script>
import { RangeSliderFi, TextInputFi } from 'atoms';

export default {
  name: 'SliderElement',
  components: {
    TextInputFi,
    RangeSliderFi,
  },
  props: {
    element: {
      type: Object,
      default: () => ({}),
    },
    group: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['change'],
  data() {
    return {
      lower: 0,
      upper: 0,
    };
  },
  computed: {
    lowerAsString: {
      get() {
        return String(this.lower);
      },
      set(value) {
        this.lower = Number(value);
      },
    },
    upperAsString: {
      get() {
        return String(this.upper);
      },
      set(value) {
        this.upper = Number(value);
      },
    },
    disabled() {
      return this.element.disabled || this.minValue + 1 >= this.maxValue;
    },
    minValue() {
      return Math.floor(Number(this.element.absoluteMinValue));
    },
    maxValue() {
      return Math.ceil(Number(this.element.absoluteMaxValue));
    },
    interval() {
      const { decimalPlaces } = this.group;
      if (!decimalPlaces) {
        return 1;
      }
      return 10 ** -decimalPlaces;
    },
  },
  created() {
    // select rounded values when fact-finder returns default outer ranges
    this.lower =
      this.element.selectedMinValue === this.element.absoluteMinValue
        ? this.minValue
        : Number(this.element.selectedMinValue);
    this.upper =
      this.element.selectedMaxValue === this.element.absoluteMaxValue
        ? this.maxValue
        : Number(this.element.selectedMaxValue);
  },
  methods: {
    onDragEndSlider(newValue) {
      if (!newValue?.length) {
        console.error('invalid newValue', newValue);
        return;
      }
      [this.lower, this.upper] = newValue;
      this.$emit('change');
    },
    onChangeSlider(newValue) {
      [this.lower, this.upper] = newValue;
    },
    onInputLower(newValueInput) {
      const newValue = Number(newValueInput);

      if (
        Number.isNaN(newValue) ||
        !Number.isInteger(newValue) ||
        newValue < this.minValue ||
        newValue > this.maxValue ||
        newValue > this.upper
      ) {
        return;
      }

      this.lower = newValue;
      this.$emit('change');
    },
    onInputUpper(newValueInput) {
      const newValue = Number(newValueInput);

      if (
        newValueInput === '' ||
        Number.isNaN(newValue) ||
        !Number.isInteger(newValue) ||
        newValue > this.maxValue ||
        newValue < this.minValue ||
        newValue < this.lower
      ) {
        return;
      }

      this.upper = newValue;
      this.$emit('change');
    },
  },
};
</script>

<style scoped src="./slider-element" />
